/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// HC - 17 Mar '23 - product page changes
document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('.hc-cannot-be-same1').forEach(element => {
      element.onchange = (event) => {
        var TempSelectValue = event.target.value

        function getAllSiblings(element, parent) {
          const children = [...parent.children]
          return children.filter(child => child !== element)
        }

        let tempAllSiblings = getAllSiblings(element.parentElement, element.parentElement.parentElement)

        tempAllSiblings.forEach(el => {
          var tempSelect = el.querySelector('.hc-cannot-be-same1')
          if (tempSelect != null) {
            tempSelect.querySelectorAll('option').forEach(opt => {
                  opt.disabled = false
            })
            tempSelect.querySelectorAll('option').forEach(opt => {
              if (opt.value == TempSelectValue) {
                  opt.disabled = true
              }
            })
          }
        })
        
      }
  })
})